import { render } from "./App.vue?vue&type=template&id=3178a506"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/home/demit/Projects/SMS-Syariah/server/app/corporate/sms-pay-corporate/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__